import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  planned_credit_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_credit_date: fromDatatype.TimestampTzDatatypeInterface;
  total_amount: fromDatatype.NumericDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  finance_cutoff_date_logic: fromDatatype.VarcharDatatypeInterface;
  finance_cutoff_day_of_month: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_date_logic: fromDatatype.VarcharDatatypeInterface;
  approval_cutoff_day_of_month: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_day_count: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_start_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_cutoff_end_date: fromDatatype.TimestampTzDatatypeInterface;
  cycle_month: fromDatatype.NumericDatatypeInterface;
  cycle_year: fromDatatype.NumericDatatypeInterface;
  approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  bank_report_total_amount: fromDatatype.NumericDatatypeInterface;
  cross_billing_report_total_amount: fromDatatype.NumericDatatypeInterface;
  pv_details_report_total_amount: fromDatatype.NumericDatatypeInterface;
  pivot_report_total_amount: fromDatatype.NumericDatatypeInterface;
  finance_last_review_date_logic: fromDatatype.VarcharDatatypeInterface;
  finance_last_review_day_of_month: fromDatatype.NumericDatatypeInterface;
  finance_last_review_day_count: fromDatatype.NumericDatatypeInterface;
  finance_review_start_date: fromDatatype.TimestampTzDatatypeInterface;
  finance_review_end_date: fromDatatype.TimestampTzDatatypeInterface;
  extension_date_logic: fromDatatype.VarcharDatatypeInterface;
  extension_day_of_month: fromDatatype.NumericDatatypeInterface;
  extension_day_count: fromDatatype.NumericDatatypeInterface;
  extension_start_date: fromDatatype.TimestampTzDatatypeInterface;
  extension_end_date: fromDatatype.TimestampTzDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  fiscal_year_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year: fromDatatype.NumericDatatypeInterface;
  fiscal_period: fromDatatype.NumericDatatypeInterface;
  comp_name: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  xtn_payment_voucher_reference_no: fromDatatype.VarcharDatatypeInterface;
  total_claim_document_line_on_loading: fromDatatype.NumericDatatypeInterface;
  xtn_syncing_status: fromDatatype.VarcharDatatypeInterface;
  xtn_syncing_date: fromDatatype.TimestampTzDatatypeInterface;
  xtn_destination_source: fromDatatype.VarcharDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_hdr_RowClass implements bl_aat_claim_cycle_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  planned_credit_date: fromDatatype.TimestampTzDatatypeInterface;
  actual_credit_date: fromDatatype.TimestampTzDatatypeInterface;
  total_amount: fromDatatype.NumericDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  finance_cutoff_date_logic: fromDatatype.VarcharDatatypeInterface;
  finance_cutoff_day_of_month: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_date_logic: fromDatatype.VarcharDatatypeInterface;
  approval_cutoff_day_of_month: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_day_count: fromDatatype.NumericDatatypeInterface;
  approval_cutoff_start_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_cutoff_end_date: fromDatatype.TimestampTzDatatypeInterface;
  cycle_month: fromDatatype.NumericDatatypeInterface;
  cycle_year: fromDatatype.NumericDatatypeInterface;
  approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  bank_report_total_amount: fromDatatype.NumericDatatypeInterface;
  cross_billing_report_total_amount: fromDatatype.NumericDatatypeInterface;
  pv_details_report_total_amount: fromDatatype.NumericDatatypeInterface;
  pivot_report_total_amount: fromDatatype.NumericDatatypeInterface;
  finance_last_review_date_logic: fromDatatype.VarcharDatatypeInterface;
  finance_last_review_day_of_month: fromDatatype.NumericDatatypeInterface;
  finance_last_review_day_count: fromDatatype.NumericDatatypeInterface;
  finance_review_start_date: fromDatatype.TimestampTzDatatypeInterface;
  finance_review_end_date: fromDatatype.TimestampTzDatatypeInterface;
  extension_date_logic: fromDatatype.VarcharDatatypeInterface;
  extension_day_of_month: fromDatatype.NumericDatatypeInterface;
  extension_day_count: fromDatatype.NumericDatatypeInterface;
  extension_start_date: fromDatatype.TimestampTzDatatypeInterface;
  extension_end_date: fromDatatype.TimestampTzDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  fiscal_year_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_year: fromDatatype.NumericDatatypeInterface;
  fiscal_period: fromDatatype.NumericDatatypeInterface;
  comp_name: fromDatatype.VarcharDatatypeInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  xtn_payment_voucher_reference_no: fromDatatype.VarcharDatatypeInterface;
  total_claim_document_line_on_loading: fromDatatype.NumericDatatypeInterface;
  xtn_syncing_status: fromDatatype.VarcharDatatypeInterface;
  xtn_syncing_date: fromDatatype.TimestampTzDatatypeInterface;
  xtn_destination_source: fromDatatype.VarcharDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
}
